import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Collaborateagency() {
  return (
    <section className="collaborate_agency p-100 tekrevol_dark_bg">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Collaborate With A Proven Android App Development Agency</h2>
            <p>
              Working with an Android application development company like
              TekRevol means you get a team that understands your needs,
              develops your app efficiently, and supports you at every step.
              Having a proven track record in the industry, we are well-equipped
              to handle diverse requirements for Android app solutions. The
              global rating below justifies our current value in the market
            </p>
          </Col>
        </Row>
        <Row>
          {/* <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="collaborate_main">
              <div className="collaborate_agency_item">
                <div className="collaborate_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/reviews/clutch.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={170}
                    height={54}
                  />
                </div>
                <div className="collaborate_flex">
                  <div className="collaborate_num">4.8</div>
                  <div className="collaborate_num_content">
                    <p>Average Review Rating on Clutch</p>
                  </div>
                </div>
              </div>
              <div className="collaborate_agency_item">
                <div className="collaborate_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/reviews/good_firms.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={363}
                    height={54}
                  />
                </div>
                <div className="collaborate_flex">
                  <div className="collaborate_num">5.0</div>
                  <div className="collaborate_num_content">
                    <p>Average Review Rating on GoodFirms</p>
                  </div>
                </div>
              </div>
              <div className="collaborate_agency_item">
                <div className="collaborate_img">
                  <StaticImage
                    src="../../images/services-usa/android-new/reviews/right_firms.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={335}
                    height={54}
                  />
                </div>
                <div className="collaborate_flex">
                  <div className="collaborate_num">4.8</div>
                  <div className="collaborate_num_content">
                    <p>Average Review Rating on RightFirms</p>
                  </div>
                </div>
              </div>
            </div>
          </Col> */}
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="collaborate_agency_item">
              <div className="collaborate_img">
                <StaticImage
                  src="../../images/services-usa/android-new/reviews/clutch.webp"
                  alt="tekrevol_web"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={170}
                  height={54}
                />
              </div>
              <div className="collaborate_flex">
                <div className="collaborate_num">4.8</div>
                <div className="collaborate_num_content">
                  <p>Average Review Rating on Clutch</p>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="collaborate_agency_item">
              <div className="collaborate_img">
                <StaticImage
                  src="../../images/services-usa/android-new/reviews/good_firms.webp"
                  alt="tekrevol_web"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={363}
                  height={54}
                />
              </div>
              <div className="collaborate_flex">
                <div className="collaborate_num">5.0</div>
                <div className="collaborate_num_content">
                  <p>Average Review Rating on GoodFirms</p>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="collaborate_agency_item">
              <div className="collaborate_img">
                <StaticImage
                  src="../../images/services-usa/android-new/reviews/right_firms.webp"
                  alt="tekrevol_web"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={335}
                  height={54}
                />
              </div>
              <div className="collaborate_flex">
                <div className="collaborate_num">4.8</div>
                <div className="collaborate_num_content">
                  <p>Average Review Rating on RightFirms</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Collaborateagency;
